import { ReactNode } from 'react'
import Sidebar from './Sidebar'
import BottomNav from './BottomNav'
import Header from './Header'

interface LayoutProps {
  children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      {/* 电脑端侧边栏 */}
      <div className="hidden md:block">
        <Sidebar />
      </div>

      {/* 主内容区 */}
      <div className="md:pl-64">
        {/* 顶部导航 */}
        <Header />

        {/* 页面内容 */}
        <main className="p-4 md:p-6 pb-20 md:pb-6">
          {children}
        </main>
      </div>

      {/* 手机端底部导航 */}
      <div className="md:hidden">
        <BottomNav />
      </div>
    </div>
  )
}
